import React from "react";
import { useState, useEffect, useRef } from "react";
import { useStores } from "../../store/index";
import { useObserver } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { EnrolledCourseCircle } from "./dashboard";
import Loader from "../reusble_components/loader";
import "../../index.css";
import { EnrollForCourses } from "./dashboard";
import {
  AiOutlineDoubleRight,
  AiOutlineRightCircle,
} from "react-icons/ai";
import HelpCenter from "../reusble_components/helpCenter";
import { EnrolledCoursesProgressBar1 } from "./learn1";
import SearchBar from "./SearchBar";
export default function Learn() {
  const { UserStore } = useStores();
  const { LearningStore } = useStores();
  const [popup, setPopup] = useState(false);
  const [id, setId] = useState(null);
  const listCourseRef = useRef(null);
  useEffect(() => {
    LearningStore.getCourseListFromApi();
  }, []);
  // const navigate = useNavigate();
  const showingPopUp = (courseid) => {
    setPopup(true);
    setId(courseid);
  };
  return useObserver(() => (
    <>
      <Loader loader={LearningStore.loading} />
      {/* <div className="flex  items-center flex-wrap w-[100%] h-full">
                {
                    LearningStore.courseList
                        .slice()
                        .sort((a, b) => a?.sort - b?.sort)
                        .map((course, index) => (
                            <div className="w-[15%] p-2 m-2">
                                <div className="flex justify-center items-center flex-col md:w-[100%] lg:w-[100%] w-[50%] rounded-md  shadow-md h-full cursor-pointer" onClick={() => goToCourseById(course?._id)} key={index}>
                                    <img className="w-[80px] h-[80px] rounded-full mb-1" src={course?.image} alt="" />
                                    <h1 className="text-text_color3 text-center text-lg font-bold">{course?.title}</h1>

                                </div>
                                {
                                    popup ? (
                                        <div className="fixed inset-0 flex flex-col items-center justify-center z-50" >
                                            <div className="bg-bg3 flex flex-col rounded-lg w-[20%] h-[100px] shadow-md">
                                                <div className="flex justify-end ">
                                                    <div className="text-xl text-center px-2 cursor-pointer" onClick={() => setPopup(false)}>x</div>
                                                </div>
                                                <div className="flex  justify-center items-center">
                                                    <button className="bg-primary2 text-text_color3 hover:bg-primary hover:text-bg3 w-[80px]  p-2 m-2 rounded-md">Enroll</button>
                                                    <button className="bg-primary2 text-text_color3 hover:bg-primary hover:text-bg3 w-[80px] p-2 m-2 rounded-md" onClick={() => goToCourseById(id)}>View</button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                        : null
                                }
                            </div>
                        ))
                }

            </div > */}
      {/* <EnrolledCoursesComponent onClickEmptyEnroll={() => {
        try {
          listCourseRef.current.scrollIntoView({ behavior: "smooth" })
        } catch (error) {
        }
      }

      } /> */}
      <SearchBar value="Search by course"></SearchBar>
      {/* <div className="flex items-center">
        <p className="font-bold text-lg ml-[30px] p-6">
          Hai, {UserStore?.userDetails?.name} welcome to Re
          <span className="text-primary">AI</span>dy
        </p>
        <div className="ml-auto">
          <div className="flex items-center">
            <input
              type="text"
              placeholder="Search by topic"
              className="border p-2 rounded-lg focus:outline-none"
            />
            <button className="bg-primary text-white p-2 rounded-r">
              Search
            </button>
          </div>
        </div>
      </div> */}

      <div className="pt-6">
        <h1 className="text-3xl md:ml-[30px] lg:text-3xl text-orange-500">
          Enrollment Courses
        </h1>
        <EnrolledCoursesProgressBar1
          onCLickEmptyEnroll={() => {
            try {
              document
                .getElementById("listCourse")
                .scrollIntoView({ behavior: "smooth" });
            } catch (error) {}
          }}
        ></EnrolledCoursesProgressBar1>
      </div>
      <div className="my-[3%] w-[100]">
        <h2 className="text-3xl ml-[30px] lg:text-3xl " id="listCourse">
          Select Course to Enroll
        </h2>
        <ListCourses />
      </div>
      <HelpCenter />
    </>
  ));
}

export function ListCourses() {
  const { LearningStore } = useStores();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const navigate = useNavigate();

  const goToCourseById = (courseId) => {
    if (window.innerWidth > 768) {
      navigate(`/dashboard/course/${courseId}`);
    } else {
      navigate(`/course/${courseId}`);
    }
  };

  const enrollCourse = async (courseId) => {
    const resp = await LearningStore.enrollForCourse(courseId);
    if (resp) {
      alert("Enrolled Successfully");
      goToCourseById(courseId);
    }
  };

  const AlreadyEnrolled = ({ courseId }) => {
    return (
      <>
        <div
          onClick={() => goToCourseById(courseId)}
          className="cursor-pointer bg-[#09ba21] w-full lg:p-4 lg:h-14  h-10 rounded-lg flex items-center justify-center text-bg3 opacity-100 transition-opacity duration-500 ease-in"
          role="success"
        >
          <p className="text-base lg:text-base">Enrolled</p>
        </div>
        {/* <div
          className="bg-primary2 w-[20%] flex items-center justify-center  h-10 rounded-lg cursor-pointer"
          onClick={() => goToCourseById(courseId)}
        >
          <FiEye
            className={`${LearningStore.checkCourseEnrolled(courseId)
              ? "text-[#09ba21]"
              : "text-primary"
              }  text-md `}
          />
        </div> */}
      </>
    );
  };

  const NotEnrolled = ({ courseId }) => {
    return (
      <>
        <button
          onClick={() => goToCourseById(courseId)}
          className="bg-primary w-full  h-10 rounded-lg lg:h-14 lg:text-xl text-bg3 cursor-pointer"
        >
          <p className="lg:text-xl md:text-base flex items-center gap-2 justify-center">
            {" "}
            View <AiOutlineRightCircle />
          </p>
        </button>
        {/* <div
          className="bg-primary2 w-[20%] flex items-center justify-center  h-10 rounded-lg cursor-pointer"
          onClick={() => enrollCourse(courseId)}
        >
          <AiOutlineBook className={`text-primary  text-md `} />
        </div> */}
      </>
    );
  };

  return (
    <div className="flex md:flex-row md:flex-wrap lg:flex-row lg:flex-wrap flex-col">
      {LearningStore.courseList
        .slice()
        .sort((a, b) => a?.sort - b?.sort)
        .map((course, index) => (
          <div
            key={index}
            className={`transition-transform hover:transition-transform transform hover:transform hover:scale-105 duration-500 hover:duration-500 hover:opacity-100 transition-timing-function:ease-in-out h-[50vh] lg:h-[45vh] w-[42vh] md:w-[35vh] lg:w-[37vh] py-3 ml-[3%] align-center flex flex-col rounded-xl justify-between mt-8 interviewshadowone border-primary2 mb-10  ${
              LearningStore.checkCourseEnrolled(course?._id) ? "" : ""
            }  h-[400px] overflow-hidden`}
            onMouseEnter={() => {
              if (isDesktop) {
                setHoveredIndex(index);
              }
            }}
            onMouseLeave={() => {
              if (isDesktop) {
                setHoveredIndex(null);
              }
            }}
          >
            <div className="flex pl-9 w-[30vh] mb-3 ">
              <img
                className="h-[100px] w-[100px] rounded-full border-2 mr-10 border-primary border-opacity-50 p-1 object-cover"
                src={course?.image}
                alt=""
              />
            </div>
            <h3 className="text-xl px-[2rem] overflow-hidden  truncate whitespace-nowrap lg:text-2xl   ">
              {course?.title ? course.title : ""}
            </h3>
            {/* <div className="flex ">
              <p className="px-8 pb-1 text-base lg:text-2xl">
                Topics: <span className="font-semibold">-{}</span>
              </p>
              <p className="px-8 py-1 flex items-center text-base lg:text-2xl">
                <IoTimeOutline /> : <span className="font-semibold">-{}</span>
              </p>
            </div> */}
            <p className="px-3 ml-5 mb-3 text-black overflow-ellipsis opacity-80 text-xs lg:text-base md:w-[200px] lg:w-[400px] overflow-hidden h-[100px] xl:pr-14 ">
              {course?.description}
            </p>

            {/* {hoveredIndex === index ? ( */}
            <div className="flex flex-row w-[80%] mx-7 lg:h-14 lg:text-3xl lg:pb-8  justify-between items-center ">
              {
                LearningStore.checkCourseEnrolled(course?._id) ? (
                  // {() => AlreadyEnrolled(course?._id) }
                  <AlreadyEnrolled courseId={course?._id} />
                ) : (
                  <NotEnrolled courseId={course?._id} />
                )

                /* <button
                   onClick={() => goToCourseById(course?._id)}
                   className="bg-primary w-[78%]  h-10 rounded-lg text-bg3 cursor-pointer"
                 >
                   View
                 </button> */
              }
            </div>
            {/* ) : ( */}
            {/* <div className="flex justify-center opacity-100 transition-opacity lg:pb-4  duration-500 ease-in">
                <button
                  onClick={() => goToCourseById(course?._id)}
                  className="bg-primary w-[80%] h-10 rounded-lg lg:h-14 lg:text-xl  flex items-center justify-center space-x- text-bg3 "
                >
                  {" "}
                  <p className="pr-3 ">Enroll course</p>
                  <CiCircleChevRight />
                </button>
              </div> */}
            {/* )} */}
          </div>
        ))}
    </div>
  );
}

export function EnrolledCoursesComponent({ onClickEmptyEnroll }) {
  const { LearningStore } = useStores();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();
  const h1Ref = useRef(null);
  const goToCourseById = (courseId) => {
    navigate(`/dashboard/course/${courseId}`);
  };

  const scrollToTop = () => {
    try {
      if (h1Ref.current) {
        h1Ref.current.scrollIntoView({ behavior: "instant" });
      }
    } catch (error) {}
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <div ref={h1Ref}></div>
      <div className="flex pt-14 flex-col md:mt-[4%] lg:mt-[4%] mt-0 mx-8 w-[100%] ">
        <p className="text-[20px]  font-semibold">Enrolled Courses</p>
        <div className="flex flex-row  w-[90%]  overflow-x-auto no-scrollbar">
          {LearningStore.enrolledCourses.length === 0 && (
            <EnrollForCourses
              onClick={() => {
                if (onClickEmptyEnroll) {
                  return onClickEmptyEnroll();
                }
              }}
            />
          )}
          {LearningStore.enrolledCourses
            .slice()
            .sort((a, b) => b?.createdAt - a?.createdAt)
            .map((enroll, index) => (
              <div
                className={`hover:border-2 hover:border-primary rounded-lg  md:w-[15vw] md:h-[35vh]`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <EnrolledCourseCircle
                  key={index}
                  label={enroll?.course?.title}
                  score={LearningStore.getTheCourseCompletionPercentage(
                    enroll?.course?._id
                  )}
                  image={enroll?.course?.image}
                  id={enroll?.course?._id}
                />
                <div className="w-full flex items-center justify-center">
                  {hoveredIndex === index && (
                    <p
                      className="text-primary cursor-pointer text-sm flex flex-row items-center justify-center  hover:border-b-2 hover:border-primary"
                      onClick={() => goToCourseById(enroll?.course?._id)}
                    >
                      Continue <AiOutlineDoubleRight />
                    </p>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
